import { createStore } from 'vuex'
import auth from './Module/auth';
import player from './Module/player';
import settings from './Module/settings';
import notifications from './Module/notifications';
import favorites from './Module/favorites';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    player,
    settings,
    notifications,
    favorites,
  }
});


